import { useMemo } from 'react';
import { useAssetViewerState } from '@hooks/useAssetViewerState';

function useSelectedMVComment() {
  const { selectedCommentId, commentsList } = useAssetViewerState();
  const comment = useMemo(
    () => commentsList.find((el) => el.id === selectedCommentId),
    [commentsList, selectedCommentId]
  );
  return comment;
}

export default useSelectedMVComment;
